<template>
  <div class="pop-login" :class="{ show: show }">
    <iframe :src="iframeSrc" frameborder="0" ref="iframe"></iframe>
  </div>
</template>

<script>
import { mapMutations,mapState } from "vuex";
import eventBus from "@/lib/eventbus.js"

// let data = {
//   channel: "email",
//   isLogin: true,
//   session: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJuaW5qYTMuYWNjb3VudC13ZWItc3NvLmNvbSIsImV4cCI6MTY5NTk3NzU1NiwianRpIjoiZTE3NzgyZDktODg1Yy00Mzc3LTkzYmUtZGNmNmY5MTVlMzkwIiwiaWF0IjoxNjkzMzg1NTU2LCJpc3MiOiJhY2NvdW50LXdlYi1zc28uY29tIiwic3ViIjoiODkzMzYwNjQ4MzAyNDAwNzQ0NiJ9.ihpgljyXf75M_Tn4r_r5ELJV_wj3ga1_NhXRa8w9qIY",
//   type: "login_sso",
// }
// token：82101c25218d0275740991ade4cd7d78
export default {
  name: "login-iframe",
  data() {
    return {
      first: false,
    }
  },
  mounted() {
    console.log("first:", this.first);
    window.addEventListener("message", this.messageEvent)

    eventBus.$on("afterTokenInvalid",()=>{
      this.first = false
    })
  },
  computed: {
    ...mapState(["curLan"]),
    iframeSrc() {
      let lan2lan = {
        tc:"hant",
        ja:"ja",
        en:"en",
        ko:"ko",
      }

      let lan = lan2lan[this.curLan] || "hant"

      // return `https://webaccount.pandadagames.com/login/login?lang=${lan}&bussiness=twitch-drop-sso`
      return `https://webaccount-mirror.pandadagames.com/login?lang=${lan}&bussiness=twitch-drop-sso`
      // if(process.env._MY_ENV == 'DEV' || process.env._MY_ENV == 'TEST'){
      //   return `https://webaccount-mirror.pandadagames.com/login?lang=${lan}`
      // } else {
      //   return `https://webaccount.pandadagames.com/login/login?lang=${lan}`
      // }
    },
    show() {
      return this.$store.state.pop.login;
    },
  },
  methods: {
    ...mapMutations(["popClose", "updateState"]),
    close() {
      this.popClose("login");
    },
    messageEvent(event) {
      console.log(event)
      if(!event || !event.data){
        return
      }
      if (event.data.type === "close") {
        this.close()
      }

      // todo 正式改成event.data
      if (event.data.isLogin) {
        if (this.first) {
          return
        }
        // console.log("message event", event)

        this.first = true

        // this.updateState({
        //   name: "isLogin",
        //   value: true,
        // })
        this.updateState({
          name: "session",
          value: event.data.session,
        })

        eventBus.$emit("afterPopUpLogin")

        this.close()
      }
    }
  },
  unmounted() {
    window.removeEventListener("message", this.messageEvent);
  },
}
</script>

<style lang="less" scoped>
.pop-login {
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: none;

  &.show {
    display: flex;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
